function pad(n) {
  return String(n).padStart(2, "0");
}

function toIcsUtc(d) {
  return (
    d.getUTCFullYear() +
    pad(d.getUTCMonth() + 1) +
    pad(d.getUTCDate()) +
    "T" +
    pad(d.getUTCHours()) +
    pad(d.getUTCMinutes()) +
    pad(d.getUTCSeconds()) +
    "Z"
  );
}

function dateCompact(isoDate) {
  return isoDate.replace(/-/g, "");
}

function nextDayCompact(isoDate) {
  const [y, m, d] = isoDate.split("-").map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d + 1));
  return dt.getUTCFullYear() + pad(dt.getUTCMonth() + 1) + pad(dt.getUTCDate());
}

function localCompact(iso) {
  return iso.replace(/[-:]/g, "").replace(/\.\d+/, "");
}

function escapeText(s) {
  return String(s == null ? "" : s)
    .replace(/\\/g, "\\\\")
    .replace(/;/g, "\\;")
    .replace(/,/g, "\\,")
    .replace(/\r?\n/g, "\\n");
}

function hashCode(s) {
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = ((h << 5) - h + s.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

function isTimed(ev) {
  return !!(ev && ev.start && ev.end);
}

export function isCalendarReady(ev) {
  return !!(ev && (isTimed(ev) || ev.date));
}

export function buildGoogleCalendarUrl(ev) {
  const params = new URLSearchParams();
  params.set("action", "TEMPLATE");
  params.set("text", ev.title || "");
  if (isTimed(ev)) {
    params.set("dates", localCompact(ev.start) + "/" + localCompact(ev.end));
    if (ev.timezone) params.set("ctz", ev.timezone);
  } else {
    params.set("dates", dateCompact(ev.date) + "/" + nextDayCompact(ev.date));
  }
  if (ev.location) params.set("location", ev.location);
  if (ev.description) params.set("details", ev.description);
  return "https://calendar.google.com/calendar/render?" + params.toString();
}

export function buildIcs(ev) {
  const uid =
    "beef-" +
    (isTimed(ev) ? localCompact(ev.start) : dateCompact(ev.date || "")) +
    "-" +
    hashCode(ev.title || "") +
    "@netflixstudios";
  const lines = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//BEEF Wellness Week//EN",
    "CALSCALE:GREGORIAN",
    "BEGIN:VEVENT",
    "UID:" + uid,
    "DTSTAMP:" + toIcsUtc(new Date()),
  ];
  if (isTimed(ev)) {
    const tzid = ev.timezone || "America/Los_Angeles";
    lines.push("DTSTART;TZID=" + tzid + ":" + localCompact(ev.start));
    lines.push("DTEND;TZID=" + tzid + ":" + localCompact(ev.end));
  } else {
    lines.push("DTSTART;VALUE=DATE:" + dateCompact(ev.date));
    lines.push("DTEND;VALUE=DATE:" + nextDayCompact(ev.date));
  }
  lines.push("SUMMARY:" + escapeText(ev.title));
  if (ev.description) lines.push("DESCRIPTION:" + escapeText(ev.description));
  if (ev.location) lines.push("LOCATION:" + escapeText(ev.location));
  lines.push("END:VEVENT", "END:VCALENDAR");
  return lines.join("\r\n");
}

export function downloadIcs(ev, filename) {
  const blob = new Blob([buildIcs(ev)], {
    type: "text/calendar;charset=utf-8",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "event.ics";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
